export const formatDateToIsraeliString = (dateStr) => {
  if (!dateStr) return null
  const date = new Date(dateStr)
  const day = String(date.getUTCDate()).padStart(2, '0')
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const year = date.getUTCFullYear()
  return `${day}/${month}/${year}`
}

export const mapAndTranslate = (list, translationMap) => {
  return list.map((term) => {
    const translated = translationMap[term] || term
    return `${term} / ${translated}`
  })
}

export const translationMap = {
  Action: 'אקשן',
  Adventure: 'הרפתקאות',
  'Avant Garde': 'אנימה ניסיונית',
  'Award Winning': 'זוכה פרס',
  'Boys Love': 'אהבת בנים',
  Comedy: 'קומדיה',
  Drama: 'דרמה',
  Fantasy: 'פנטזיה',
  'Girls Love': 'אהבת בנות',
  Gourmet: 'בישול',
  Horror: 'אימה',
  Mystery: 'מסתורין',
  Romance: 'רומנטיקה',
  'Sci-Fi': 'מדע בדיוני',
  'Slice of Life': 'חלק מהחיים',
  Sports: 'ספורט',
  Supernatural: 'על טבעי',
  Suspense: 'מתח',
  'Adult Cast': 'קהל בוגר',
  Anthropomorphic: 'האנשה',
  CGDCT: 'בנות חמודות',
  Childcare: 'טיפול בילדים',
  'Combat Sports': 'קרבות ספורט',
  Crossdressing: 'הלבשה',
  Delinquents: 'עבריינות',
  Detective: 'בלשות',
  Educational: 'חינוכי',
  'Gag Humor': 'קומדיה הומוריסטית',
  Gore: 'גור',
  Harem: 'הרמון (נשים)',
  'High Stakes Game': 'משחקי מזל',
  Historical: 'היסטורי',
  'Idols (Female)': 'מפורסמת',
  'Idols (Male)': 'מפורסם',
  Isekai: 'עולם אחר',
  Iyashikei: 'מצב ריפוי',
  'Love Polygon': 'אהבה יותר מאישה אחת',
  'Love Status Quo': 'משולש אהבה',
  'Magical Sex Shift': 'שינוי מגדרי קסום',
  'Mahou Shoujo': 'ילדות קסומות',
  'Martial Arts': 'אומנויות לחימה',
  Mecha: 'רובוטים',
  Medical: 'רפואה',
  Military: 'צבאי',
  Music: 'מוזיקה',
  Mythology: 'מיתולוגיה',
  'Organized Crime': 'פשע מאורגן',
  'Otaku Culture': 'תרבות האוטקו',
  Parody: 'פרודיה',
  'Performing Arts': 'אמנות במה',
  Pets: 'חיות',
  Psychological: 'פסיכולוגיה',
  Racing: 'מרוצים',
  Reincarnation: 'חזר לחיים',
  'Reverse Harem': 'הרמון (גברים)',
  Samurai: 'סמוראי',
  School: 'בית ספר',
  Showbiz: 'תעשיית הבידור',
  Space: 'חלל',
  'Strategy Game': 'משחק אסטרטגיה',
  'Super Power': 'כוחות מיוחדים',
  Survival: 'הישרדות',
  'Team Sports': 'ספורט קבוצתי',
  'Time Travel': 'מסע בזמן',
  'Urban Fantasy': 'פנטזיה אורבנית',
  Vampire: 'ערפדים',
  'Video Game': 'משחק מחשב',
  Villainess: 'נבלות',
  'Visual Arts': 'אומנות חזותית',
  Workplace: 'מקום עבודה',
  Josei: 'נשים',
  Kodomo: 'ילדים',
  Seinen: 'מתבגרים',
  Shoujo: 'נערה',
  Shounen: 'נער',
}

export const translatedStatus = {
  'Finished Airing': 'הסתיים',
  'Currently Airing': 'בשידור',
  'Not yet aired': 'עדיין לא שודר',
}

export const translatedSeason = {
  winter: 'חורף',
  spring: 'אביב',
  summer: 'קיץ',
  fall: 'סתיו',
}

export const translatedRating = {
  'G - All Ages': 'לכולם',
  'PG - Children': 'לכולם',
  'PG-13 - Teens 13 or older': '13+',
  'R - 17+ (violence & profanity)': '18+',
  'R+ - Mild Nudity': '18+',
}

export const daysTranslation = {
  Sundays: 'ראשון',
  Mondays: 'שני',
  Tuesdays: 'שלישי',
  Wednesdays: 'רביעי',
  Thursdays: 'חמישי',
  Fridays: 'שישי',
  Saturdays: 'שבת',
}

export const extractMinutes = (duration) => {
  if (!duration) return 'לא צויין'
  const hours = duration.match(/(\d+)\s*hr/)?.[1] || 0
  const minutes = duration.match(/(\d+)\s*min/)?.[1] || 0
  return `${parseInt(hours) * 60 + parseInt(minutes)} דקות`
}
